// export const games = {
//     "yx": "Jogo",
//     "yxms": "No jogo criptografado, todas as decisões que determinam os resultados da competição são geradas antecipadamente na forma de hashes, e os resultados do jogo não serão alterados pela vontade de ninguém, garantindo absoluta justiça!",
//     "mnsm": "Simulação de Jogo",
//     "ljqw": "Jogar Agora",
//     loading: 'Carregando, por favor aguarde'
// }
export const games = {
    yx: 'jogo',
    yxms: 'Todos os resultados das decisões do jogo criptografado são gerados na forma de hash antes da participação, não podendo ser alterados pela vontade de ninguém, garantindo justiça e equidade absolutas!',
    mnsm: 'jogo de simulação',
    ljqw: 'jogar agora',
    loading: 'carregando, por favor aguarde',
    dyh: 'Contratos de opções diversificados para você escolher, lucro de 100 vezes, retorno do investimento super alto no curto prazo',
    qyhy:'contrato de opções',
    qsyhys:'opções',
    kd:'Abra um pedido',
    qt:'Investimento',
    ljjy: "Negocie agora",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/pt_BR.js